// src/components/Countries/CountryDrawer.js
import React from 'react';
import { Drawer } from 'antd';
import CountryForm from './CountryForm';

const CountryDrawer = ({ visible, onClose, _id }) => (
  <Drawer
    title={_id ? "Edit Country" : "Add Country"}
    width={720}
    onClose={onClose}
    visible={visible}
  >
    <CountryForm _id={_id} onClose={onClose} />
  </Drawer>
);

export default CountryDrawer;
